import { render, staticRenderFns } from "./IbkNoticeBox.vue?vue&type=template&id=ab673ed2&scoped=true&"
import script from "./IbkNoticeBox.vue?vue&type=script&lang=js&"
export * from "./IbkNoticeBox.vue?vue&type=script&lang=js&"
import style0 from "./IbkNoticeBox.vue?vue&type=style&index=0&id=ab673ed2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab673ed2",
  null
  
)

export default component.exports